import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Backdrop } from "@mui/material";
import '../Repayment/Repayment.css';
import environment from '../../environment/environment';
import CustomSpinner from '../../components/CustomeSpinner/CustomeSpinner';

function Repayment({ repaymentDetails }
) {
  const [totalAmount, setTotalAmount] = useState(0);
  const navigate = useNavigate();
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setPaymentDetails(repaymentDetails);
    setTotalAmount((repaymentDetails.pendingAmount));
  }, [repaymentDetails])
  
  const createOrder = async () => {
    setIsLoading(true);
    const requestBody = {
      "amount": "1",
      "mode": "Test Mode"
    }
    const result = await axios.post(`${environment.config.apiOrderUrl}payment/createOrder`, {
      "amount": paymentDetails?.pendingAmount,
      "mode": "Test Mode",
    });

    const options = {
      // key: 'rzp_live_ZepLWVVvssYGcF', // Enter the Key ID generated from Razorpay Dashboard
      key: 'rzp_test_Dk9GIcyaizdBM9',
      amount: result.data.paymentDetails?.pendingAmount,
      currency: "INR",
      name: "Ghoomo World",
      description: "Test Transaction",
      order_id: result.data.id,
      handler: function (response) {
        // alert(`Payment Successful! Payment ID: ${response.razorpay_payment_id}`);
        // Send this response to backend to verify payment
        if (response) {
          inItPayment(result.data.id, response.razorpay_payment_id);
          navigate('/payment-success');
        }
        setTimeout(() => {
          setIsLoading(false)
        }, 1500);
      },
      prefill: {
        name: "Your Name",
        email: "email@example.com",
        contact: "9503577602"
      },
      theme: {
        color: "#3399cc",
      },
      modal: {
        ondismiss: function () {
          setIsLoading(false);
        },
      }
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const inItPayment = (order_id, payment_id) => {
    const accessToken = localStorage.getItem('accessToken');
    const requestBody = {
      "paymentOrderId": order_id,
      "transactionId": payment_id,
      "pendingAmount": "0",
      "paidAmount": Number(paymentDetails.pendingAmount).toFixed(2)
    }
    axios.put(`${environment.config.apiOrderUrl}order/${paymentDetails.orderId}/updatedMakePayment`, requestBody)
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'end' }}>
      {isLoading &&
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0, 0, 0, 0.4)"
          }}
          open={isLoading}
        >
          <CustomSpinner color="inherit" />
        </Backdrop>
      }
      <button
        className="btn btn-primary desktopbtn"
        onClick={createOrder}
        style={{ backgroundColor: '#fff099', color: '#2d2b29', width: '100%', border: '1px solid #fff099'}}
      >
        Make Payment (&#8377; {totalAmount})
      </button>
      <button
        className="btn btn-primary mobilebtn"
        onClick={createOrder}
        style={{ backgroundColor: '#fff099', color: '#2d2b29', width: '100%', border: '1px solid #fff099'}}
      >
        Pay Now
      </button>
    </div>
  );
}

export default Repayment;
